import React from 'react'
import SubscriptionBlockWrapper from './SubscriptionBlockWrapper'

const SubscriptionContent = ({ currentPlan, openProjectName, t }) => {
	// OMP subscription - show only OMP in Tax project if OMP subscription exists
	if (openProjectName === 'LTax' && currentPlan?.subscriptions_omp) {
		return (
			<SubscriptionBlockWrapper
				type="omp"
				sub={currentPlan.subscriptions_omp}
				currentPlan={currentPlan}
				t={t}
			/>
		)
	}

	// LTax Project - VAT and Sales Tax subscriptions
	const hasBothSubscriptions = openProjectName === 'LTax' && 
		currentPlan?.subscriptions && 
		currentPlan?.subscriptions_sales_tax

	if (hasBothSubscriptions) {
		return (
			<div className={'two-block_subscription-dashboard'}>
				<div className="first-subscription-item">
					{currentPlan?.subscriptions && (
						<SubscriptionBlockWrapper
							type="vat"
							sub={currentPlan.subscriptions}
							currentPlan={currentPlan}
							t={t}
						/>
					)}
				</div>
				<div className="second-subscription-item">
					{currentPlan?.subscriptions_sales_tax && (
						<SubscriptionBlockWrapper
							type="sales tax"
							sub={currentPlan.subscriptions_sales_tax}
							currentPlan={currentPlan}
							t={t}
						/>
					)}
				</div>
			</div>
		)
	}

	// Individual subscriptions
	return (
		<>
			{openProjectName === 'LTax' && currentPlan?.subscriptions && (
				<SubscriptionBlockWrapper
					type="vat"
					sub={currentPlan.subscriptions}
					currentPlan={currentPlan}
					t={t}
				/>
			)}
			{openProjectName === 'LTax' && currentPlan?.subscriptions_sales_tax && (
				<SubscriptionBlockWrapper
					type="sales tax"
					sub={currentPlan.subscriptions_sales_tax}
					currentPlan={currentPlan}
					t={t}
				/>
			)}
			{openProjectName === 'LEPR' && currentPlan?.subscriptions_epr && (
				<SubscriptionBlockWrapper
					type="epr"
					sub={currentPlan.subscriptions_epr}
					currentPlan={currentPlan}
					t={t}
				/>
			)}
			{openProjectName === 'LInvoice' && currentPlan?.subscriptions_invoice && (
				<SubscriptionBlockWrapper
					type="invoice"
					sub={currentPlan.subscriptions_invoice}
					currentPlan={currentPlan}
					t={t}
				/>
			)}
		</>
	)
}

export default SubscriptionContent

